import ConfirmationRoot from './routes/confirmation/ConfirmationRoot.js';
import WhereRoot from './routes/default/WhereRoot.js';
import WhatRoot from './routes/what/WhatRoot.js';
import WhenRoot from './routes/when/WhenRoot.js';
import WhoRoot from './routes/who/WhoRoot.js';

const routeMap = {
    '': WhereRoot,
    where: WhereRoot,
    what: WhatRoot,
    when: WhenRoot,
    who: WhoRoot,
    confirmation: ConfirmationRoot
};

export { routeMap };
//# sourceMappingURL=route-map.js.map
